import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import moment from 'moment';
import classNames from 'classnames';
import { DateRange } from '@/component/dateRangePicker';
import { MessageHistoryTab, ConversationHistoryTab } from './component';


type HistoryTab = 'message' | 'conversation';

const tabs = [
    { id: 'message', labelKey: 'i07001' },
    { id: 'conversation', labelKey: 'i07002' }
] as const;

const ConversationHistoryView: React.FC = () => {
    const intl = useIntl();

    const [activeTab, setActiveTab] = useState<HistoryTab>('message');
    const [period, setPeriod] = useState<DateRange>({
        start: moment().startOf('day').subtract(14, 'days'),
        end: moment().endOf('day')
    });

    return (
        <main className="scenario-content-layout pt-0 flex flex-col gap-4">
            <div role="tablist"
                 id="history-tablist"
                 aria-label={intl.formatMessage({ id: "m06" })}
                 aria-orientation="horizontal"
                 className="w-full flex items-center gap-2"
            >
                {tabs.map(tab => (
                    <button key={tab.id}
                            role="tab"
                            id={`${tab.id}-history-tab`}
                            aria-selected={activeTab === tab.id}
                            aria-controls="history-panel"
                            className={classNames(
                                "tab-btn text-black-500 font-[400] border-transparent",
                                "aria-selected:text-chat42 aria-selected:font-[600] aria-selected:border-chat42"
                            )}
                            onClick={() => setActiveTab(tab.id as HistoryTab)}
                    >
                        {intl.formatMessage({ id: tab.labelKey })}
                    </button>
                ))}
            </div>
            <div id="history-panel"
                 role="tabpanel"
                 aria-labelledby={`${activeTab}-history-tab`}
                 className="w-full flex-1 min-h-0 flex flex-col gap-3 min-w-fit"
            >
                {activeTab === 'message' && (
                    <MessageHistoryTab period={period}
                                       setPeriod={setPeriod}
                    />
                )}
                {activeTab === 'conversation' && (
                    <ConversationHistoryTab period={period}
                                            setPeriod={setPeriod}
                    />
                )}
            </div>
        </main>
    );
};

export default ConversationHistoryView;
